export default __webpack_public_path__ + "static/media/tax-rate-options-flat-rate.16c4059b.svg";